<script setup>
import SMessageChargement from '@/components/global/s-message-chargement.vue'
import VersementListItem from '@/components/fiche-aim/fiche-aim/versements/versementList/groupe-date-versement-list-item.vue'
</script>

<template>
  <div>
    <s-message-chargement class="ma-6" v-if="loading"> Chargement des mouvements </s-message-chargement>
    <v-simple-table v-else>
      <thead>
        <tr>
          <th class="text-left" colspan="1">Type de versement</th>
          <th class="text-right">Detail</th>
          <th class="text-left" colspan="2">Total</th>
        </tr>
      </thead>
      <versement-list-item
        v-for="(groupe, id) in versementsParDates"
        :key="id"
        :groupe-versement="groupe"
        @delete-versement="(versement) => handleDeleteVersement(versement)"
      />
    </v-simple-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'versements-du-mois-list',
  props: {
    mois: {
      type: Number,
      required: true,
    },
    annee: {
      type: Number,
      required: true,
    },
    usagerId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      versements: 'versement/getVersements',
      versementsParDates: 'versement/getVersementsParDates',
      etablissement: 'application/getSelectedEtablissement',
    }),
  },
  data() {
    return {
      loading: true,
    }
  },
  methods: {
    ...mapActions({
      fetchVersements: 'versement/obtenirVersementsUsagerPourMoisEtEtablissement',
      supprimerVersement: 'versement/supprimerVersement',
    }),
    handleDeleteVersement(versement) {
      this.loading = true
      this.supprimerVersement(versement).then(this.refreshVersements)
    },
    refreshVersements() {
      this.fetchVersements({
        usagerId: this.usagerId,
        etablissementId: this.etablissement.etablissementId,
        mois: this.mois,
        annee: this.annee,
      }).then((this.loading = false))
    },
  },
  watch: {
    mois() {
      this.refreshVersements()
    },
    annee() {
      this.refreshVersements()
    },
    usagerId() {
      this.refreshVersements()
    },
  },
  created() {
    this.refreshVersements()
  },
}
</script>
